import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ShiftRemark } from "../models/ShiftRemark";

const normalize = (value: string): string | null => {
	const trimmed = value.trim();
	return trimmed === "" ? null : trimmed;
};

type Props = {
	remark: ShiftRemark | null;
	disabled?: boolean;
	isMutating: boolean;
	onSave: (comment: string | null) => void;
};

export const StackerShiftRemarkField = ({
	remark,
	disabled,
	isMutating,
	onSave,
}: Props) => {
	const [value, setValue] = useState(remark?.Comment ?? "");

	useEffect(() => {
		setValue(remark?.Comment ?? "");
	}, [remark]);

	return (
		<Paper elevation={2} sx={{ overflow: "hidden" }}>
			<Box
				sx={{
					px: 2.5,
					py: 1,
					borderBottom: "1px solid",
					borderColor: "divider",
				}}
			>
				<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
					Remarks
				</Typography>
			</Box>
			<Box sx={{ p: 2 }}>
				<TextField
					fullWidth
					multiline
					minRows={3}
					maxRows={8}
					value={value}
					disabled={disabled || isMutating}
					onChange={(e) => setValue(e.target.value)}
				/>

				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						mt: 2,
					}}
				>
					<Button
						variant="contained"
						onClick={() => {
							const next = normalize(value);
							const current = remark?.Comment ?? null;
							if (next !== current) {
								onSave(next);
							}
						}}
						disabled={
							disabled ||
							isMutating ||
							normalize(value) === (remark?.Comment ?? null)
						}
					>
						Save Remark
					</Button>
				</Box>
			</Box>
		</Paper>
	);
};
